import React from "react";

import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";

import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LogoutIcon from "@mui/icons-material/Logout";

const Headerbar = ({ toggleColorMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const getPageTitle = (path) => {
    switch (path) {
      case "/":
        return "Dashboard Utenti";
      case "/associations":
        return "Dashboard Associazioni";
      case "/activation-code":
        return "Codici Associazioni";
      case "/server":
        return "Server";
      case "/logs":
        return "Logs";
      default:
        return "";
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3,
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: 500 }}>
        {getPageTitle(location.pathname)}
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Tooltip title="Cambia tema">
          <IconButton onClick={toggleColorMode}>
            {theme.palette.mode === "dark" ? (
              <LightModeIcon />
            ) : (
              <DarkModeIcon />
            )}
          </IconButton>
        </Tooltip>

        <Tooltip title="Logout">
          <IconButton
            onClick={() => {
              localStorage.clear();
              navigate("/login");
            }}
          >
            <LogoutIcon sx={{ width: 32, height: 32 }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default Headerbar;
